import axios from './axios'
/***
 * 提交预定人信息
 */

class Activity {
  submitApi(params) {
    return axios({
      url: '/Order/Extend/Submit',
      method: 'post',
      data: params
    })
  }
}

export default new Activity()
